import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import "./Blogs.css";

const BLOG_POSTS = [
  {
    id: 1,
    title: "5 Signs Your AC Needs Gas Filling",
    date: "2025",
    excerpt:
      "Is your AC blowing warm air? Learn the common signs that your unit may need a refrigerant top-up in Kamra and Attock.",
    tag: "AC Tips",
  },
  {
    id: 2,
    title: "How to Prepare for an AC Technician Visit",
    date: "2025",
    excerpt:
      "Simple steps before your technician arrives — clear access, note the problem, and have your model info ready.",
    tag: "Guides",
  },
  {
    id: 3,
    title: "Why Regular AC Maintenance Saves Money",
    date: "2025",
    excerpt:
      "Annual servicing reduces breakdowns, lowers electricity bills, and extends the life of your split or inverter AC.",
    tag: "Maintenance",
  },
];

export default function Blogs() {
  return (
    <PageLayout title="Blogs">
      <p className="blogs-intro">
        Tips, guides, and updates from the Maskanh team on AC care and home
        technical services in Kamra &amp; Attock.
      </p>

      <div className="blogs-grid">
        {BLOG_POSTS.map((post) => (
          <article key={post.id} className="blog-card">
            <span className="blog-tag">{post.tag}</span>
            <h2>{post.title}</h2>
            <p>{post.excerpt}</p>
            <span className="blog-date">{post.date}</span>
          </article>
        ))}
      </div>

      <p className="blogs-cta">
        Need service now?{" "}
        <Link to="/#request-form">Book a verified technician →</Link>
      </p>
    </PageLayout>
  );
}
